/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Table,
  Row,
  Col,
  Button,
  Icon,
  Popconfirm,
  Divider,
  Empty,
  Typography,
  message,
} from "antd";
import { formatValue } from "../../../../../utils";

const { Text } = Typography;

const FinancierContacts = ({
  form,
  data,
  setData,
  validityRef,
  clearRef,
  editable,
}) => {
  const { getFieldDecorator } = form;
  const [contacts, setContacts] = useState([]);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    if (data && data.contact) {
      setContacts(data.contact);
    }

    clearRef.current = () => form.resetFields();
    validityRef.current = () => true;

    return () => {
      validityRef.current = null;
      clearRef.current = null;
    };
  }, [data]);

  const addContact = () => {
    form.validateFields((err) => {
      if (!err) {
        const entry = {
          ...form.getFieldsValue(),
          valid: true,
          whatsapp: true,
          id: editId || "temp-" + Math.random().toString(36).substr(2, 9),
        };

        let newList = [...contacts];
        if (editId) {
          newList = newList.map((c) => (c.id === editId ? entry : c));
          setEditId(null);
        } else {
          newList.push(entry);
        }

        setContacts(newList);
        setData({ ...data, contact: newList });
        form.resetFields();
      } else {
        message.error("Please fill all required fields correctly");
      }
    });
  };

  const deleteContact = (record) => {
    const newList = contacts.filter((c) => c.id !== record.id);
    setContacts(newList);
    setData({ ...data, contact: newList });
  };

  const columns = [
    {
      title: <Text strong>Name</Text>,
      dataIndex: "name",
      key: "name",
      render: (text) => <span>{text}</span>,
    },
    {
      title: <Text strong>Designation</Text>,
      dataIndex: "designation",
      key: "designation",
      render: (text) => <span>{text}</span>,
    },
    {
      title: <Text strong>Phone Number</Text>,
      dataIndex: "number",
      key: "number",
      render: (text) => <span>{text}</span>,
    },
    {
      title: <Text strong>Action</Text>,
      render: (record) => (
        <div>
          <Icon
            type="edit"
            style={{ color: "#1890ff" }}
            onClick={() => {
              setEditId(record.id);
              form.setFieldsValue({
                name: record.name,
                designation: record.designation,
                number: record.number,
              });
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Do you want to delete this contact?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => deleteContact(record)}
          >
            <Icon type="delete" style={{ color: "red" }} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div style={{ marginTop: "2vh" }}>
      <Table
        rowKey={(record) => record.id || record.number}
        pagination={false}
        size="small"
        dataSource={contacts}
        columns={columns.filter(
          (col) => col.title.props.children !== "Action" || editable
        )}
        locale={{
          emptyText: (
            <Empty
              description={
                <Text disabled strong>
                  No Contacts
                </Text>
              }
              image={<Icon type="contacts" />}
              imageStyle={{ height: 30 }}
            />
          ),
        }}
      />

      {editable && (
        <Form style={{ marginTop: "3vh" }}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Name" required>
                {getFieldDecorator("name", {
                  rules: [{ required: true, message: "Enter name!" }],
                })(
                  <Input
                    placeholder="Name"
                    maxLength={30}
                    pattern="^[A-Z][a-zA-Z\\s]*[a-zA-Z]+$"
                    onKeyUp={(e) => {
                      const val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                      form.setFieldsValue({
                        name: val.split(' ').map(v => v.substring(0, 1).toUpperCase() + v.substring(1).toLowerCase()).join(' '),
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="Designation">
                {getFieldDecorator("designation")(
                  <Input
                    placeholder="Designation"
                    maxLength={30}
                    pattern="^[A-Z][a-zA-Z\\s]*[a-zA-Z]+$"
                    onKeyUp={(e) => {
                      const val = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                      form.setFieldsValue({
                        designation: val.split(' ').map(v => v.substring(0, 1).toUpperCase() + v.substring(1).toLowerCase()).join(' '),
                      });
                    }}
                  />
                )}
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item label="Phone Number" required>
                {getFieldDecorator("number", {
                  rules: [
                    {
                      required: true,
                      message: "Enter valid phone number!",
                      pattern: /^[0-9]{10}$/,
                    },
                  ],
                })(
                  <Input
                    addonBefore="+91"
                    placeholder="Phone Number"
                    maxLength={10}
                    onWheel={(e) => e.currentTarget.blur()}
                    onKeyUp={(e) =>
                      form.setFieldsValue({
                        number: formatValue(e, "onlyNo"),
                      })
                    }
                  />
                )}
              </Form.Item>
            </Col>

            <Col span={2}>
              <Button
                type="primary"
                style={{ marginTop: "42px" }}
                onClick={addContact}
              >
                {editId ? "Update" : "Add"}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
};

const WrappedFinancierContactsForm = Form.create({
  name: "FinancierContactsForm",
})(FinancierContacts);

export default WrappedFinancierContactsForm;
